var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5228_13331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5678 12.3424H3.01716C2.76443 12.3418 2.51901 12.2576 2.31926 12.1027C2.11951 11.9479 1.9767 11.7312 1.91316 11.4866L0.234283 5.11735C0.175706 4.90358 0.181664 4.67726 0.251408 4.46687C0.321152 4.25647 0.451565 4.07141 0.626238 3.93496C0.798498 3.79552 1.00776 3.70948 1.22829 3.68743C1.44881 3.66538 1.67097 3.70827 1.86743 3.81084L4.76789 5.29373C4.78713 5.30349 4.80839 5.30857 4.82995 5.30857C4.85152 5.30857 4.87278 5.30349 4.89201 5.29373C4.91386 5.28825 4.93411 5.2777 4.95113 5.26295C4.96815 5.2482 4.98146 5.22965 4.99 5.20881L6.72767 1.37418C6.8195 1.17683 6.96637 1.0102 7.15063 0.894316C7.33489 0.77843 7.54869 0.718222 7.76635 0.720927C7.98434 0.716565 8.19884 0.776094 8.38341 0.892174C8.56798 1.00825 8.71454 1.17581 8.80503 1.37418L10.5688 5.22841C10.5771 5.24829 10.5895 5.26616 10.6053 5.28081C10.6211 5.29547 10.6398 5.30655 10.6603 5.31333C10.6808 5.32272 10.7031 5.32759 10.7256 5.32759C10.7482 5.32759 10.7704 5.32272 10.7909 5.31333L13.6979 3.8043C13.8945 3.70196 14.1165 3.65894 14.337 3.68047C14.5575 3.702 14.7671 3.78715 14.9401 3.92557C15.1131 4.06399 15.2422 4.24971 15.3116 4.46013C15.381 4.67056 15.3878 4.89662 15.3311 5.11082L13.6457 11.4801C13.5855 11.7222 13.4474 11.9378 13.2526 12.0936C13.0578 12.2494 12.8172 12.3368 12.5678 12.3424ZM1.33829 4.64047C1.32018 4.64021 1.30219 4.64354 1.28537 4.65027C1.26856 4.657 1.25324 4.66699 1.2403 4.67967C1.2135 4.69786 1.1933 4.72423 1.18271 4.75483C1.17211 4.78544 1.17169 4.81865 1.18151 4.84952L2.86038 11.2384C2.87002 11.273 2.8904 11.3037 2.91857 11.326C2.94674 11.3483 2.98126 11.3611 3.01716 11.3625H12.5678C12.6043 11.3633 12.6399 11.3513 12.6685 11.3287C12.6972 11.306 12.717 11.2741 12.7246 11.2384L14.41 4.86911C14.4163 4.83856 14.414 4.80686 14.4034 4.7775C14.3929 4.74815 14.3744 4.72226 14.3502 4.70269C14.3259 4.68312 14.2966 4.67062 14.2657 4.66656C14.2348 4.6625 14.2033 4.66703 14.1748 4.67967L11.3005 6.1887C11.1625 6.25927 11.0117 6.30124 10.8572 6.31207C10.7026 6.32291 10.5474 6.30239 10.401 6.25175C10.2546 6.2011 10.1199 6.12138 10.005 6.01737C9.89017 5.91336 9.79752 5.78721 9.73265 5.64649L7.94273 1.7988C7.93071 1.76906 7.90987 1.74372 7.883 1.7262C7.85613 1.70868 7.82454 1.69982 7.79248 1.70081C7.7611 1.6992 7.73007 1.7079 7.70411 1.7256C7.67816 1.74329 7.65871 1.76901 7.64876 1.7988L5.88496 5.64649C5.823 5.78678 5.73312 5.913 5.62082 6.01744C5.50851 6.12189 5.37612 6.20238 5.23171 6.25402C5.08489 6.30498 4.92923 6.32547 4.77423 6.31424C4.61923 6.303 4.46814 6.26029 4.33021 6.1887L1.41668 4.67967L1.33829 4.64047Z",
    fill: "#FFD595"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5228_13331",
    x: 0.194336,
    y: 0.720703,
    width: 16.1748,
    height: 12.6221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5228_13331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5228_13331",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.a2ddfe84.svg";
export { ForwardRef as ReactComponent };